import React from 'react';
import styled from '@emotion/styled';
import List from './List';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  width: 100%;
  justify-content: center;

  @media (min-width: ${props =>
      props.theme.breakpoints.s}) and (max-width: ${props =>
      props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 30px 0;
  text-align: center;
`;
const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

const SolutionAndServices = props => {
  const { solutions, services } = props;
  return (
    <Section>
      <ContentWrapper>
        {solutions && (
          <ColumnWrapper>
            <SectionTitle>
              {solutions.title ? solutions.title : 'Solutions'}
            </SectionTitle>
            <ListContainer>
              <List items={solutions.list1} />
              <List items={solutions.list2} />
            </ListContainer>
          </ColumnWrapper>
        )}

        {services && (
          <ColumnWrapper>
            <SectionTitle>
              {services.title ? services.title : 'Services'}
            </SectionTitle>
            <ListContainer>
              <List items={services.list1} />
              <List items={services.list2} />
            </ListContainer>
          </ColumnWrapper>
        )}
      </ContentWrapper>
    </Section>
  );
};

export default SolutionAndServices;
